export default "__VITE_ASSET__8960f154__"